<template>
  <div>
    <div class="title">Gene structure</div>
    <div
      class="border"
      v-for="(totalitem, totalindex) in totalData"
      :key="totalindex"
    >
      <!--标签-->
      <div class="tag">
        <div class="ge1"></div>
        <div class="tagc">
          <ul>
            <li><div class="one"></div></li>
            <li>Promoter </li>
            <li><div class="two"></div></li>
            <li>5′UTR</li>
            <li><div class="three"></div></li>
            <li>CDS</li>
            <li><div class="four"></div></li>
            <li>3′UTR</li>
            <li></li>
          </ul>
        </div>
      </div>
      <!--Gene ID-->
      <div class="childTitle">
        <span>Gene ID</span>
      </div>
      <!--一根长条坨坨-->
      <!-- <div class="line" >
        <hr/> -->
         <div class="line" :style="{width:totalitem.lineWidth+'px'}">
        <hr  :style="{width:totalitem.lineWidth+'px'}" />
        <div
          class="lineItem"
          v-for="(item, index) in totalitem.structureList"
          :key="index"
          :style="{
            width: item.width + 'px',
            background: item.color,
            left: item.mleft + 'px',
          }"
        ></div>
        <!-- <div class="lineItemTwo"></div>
        <div class="lineItemThree"></div>
        <div class="lineItemFour"></div>
        <div class="lineItemFive"></div>
        <div class="lineItemSix"></div>
        <div class="lineItemSeven"></div> -->
      </div>
      <!--下载和隐藏-->
      <div class="download">
        <div class="btnge"></div>
        <!-- <el-button plain @click="downloadData(totalitem.transcriptId)">Download</el-button> -->
        <a
          class="downloadbtn"
          :href="
            '/bena/server/gooal/gene/structure/transcriptSeq/?transcriptId=' +
            totalitem.transcriptId +
            '&version=' +
            version
          "
          >Download</a
        >

        <el-button v-if="totalitem.show" @click="hide(totalindex)"
          >Hide</el-button
        >
        <el-button v-if="!totalitem.show" @click="show(totalindex)"
          >Show</el-button
        >
      </div>
      <!--表格-->
      <div data-v-1c5e8957="" class="table" v-if="totalitem.show">
        <div
          data-v-1c5e8957=""
          class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition"
          style="width: 100%"
        >
          <div class="hidden-columns">
            <div data-v-1c5e8957=""></div>
            <div data-v-1c5e8957=""></div>
            <div data-v-1c5e8957=""></div>
            <div data-v-1c5e8957=""></div>
            <div data-v-1c5e8957=""></div>
          </div>
          <div class="el-table__header-wrapper">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__header"
              style="width: 909px"
            >
              <colgroup>
                <col name="el-table_1_column_1" width="80" />
                <col name="el-table_1_column_2" width="208" />
                <col name="el-table_1_column_3" width="207" />
                <col name="el-table_1_column_4" width="207" />
                <col name="el-table_1_column_5" width="207" />
                <col name="gutter" width="0" />
              </colgroup>
              <thead class="has-gutter">
                <tr class="">
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_1_column_1 is-center is-leaf"
                    style="background: rgb(210, 235, 225); color: seagreen"
                  >
                    <div class="cell"></div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_1_column_2 is-center is-leaf"
                    style="background: rgb(210, 235, 225); color: seagreen"
                  >
                    <div class="cell">Chomosome</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_1_column_3 is-center is-leaf"
                    style="background: rgb(210, 235, 225); color: seagreen"
                  >
                    <div class="cell">Start</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_1_column_4 is-center is-leaf"
                    style="background: rgb(210, 235, 225); color: seagreen"
                  >
                    <div class="cell">End</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_1_column_5 is-center is-leaf"
                    style="background: rgb(210, 235, 225); color: seagreen"
                  >
                    <div class="cell">Length</div>
                  </th>
                  <th class="gutter" style="width: 0px; display: none"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="el-table__body-wrapper is-scrolling-none">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__body"
              style="width: 909px"
            >
              <colgroup>
                <col name="el-table_1_column_1" width="80" />
                <col name="el-table_1_column_2" width="208" />
                <col name="el-table_1_column_3" width="207" />
                <col name="el-table_1_column_4" width="207" />
                <col name="el-table_1_column_5" width="207" />
              </colgroup>
              <tbody>
                <tr
                  class="el-table__row"
                  v-for="(item, index) in totalitem.structureList"
                  :key="index"
                >
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_1 is-center"
                  >
                    <div class="cell">{{ item.feature }}</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_2 is-center"
                  >
                    <div class="cell">{{ item.chromosome }}</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_3 is-center"
                  >
                    <div class="cell">{{ item.start }}</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_4 is-center"
                  >
                    <div class="cell">{{ item.end }}</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_5 is-center"
                  >
                    <div class="cell">{{ item.length }}</div>
                  </td>
                </tr>

                <!---->
              </tbody>
            </table>
            <!----><!---->
          </div>
          <!----><!----><!----><!---->
          <div
            class="el-table__column-resize-proxy"
            style="display: none"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { export2Excel } from "../../../excel/util";
export default {
  data() {
    return {
      columns: [
        { title: "transcriptId", key: "transcriptId" },
        { title: "strand", key: "strand" },
        { title: "start", key: "start" },
        { title: "length", key: "length" },
        { title: "id", key: "id" },
        { title: "geneId", key: "geneId" },
        { title: "feature", key: "feature" },
        { title: "end", key: "end" },
        { title: "chromosome", key: "chromosome" },
      ],
      totalData: [],
      tableData: [],
      lineWidth:0
    };
  },
  props: ["id", "version"],
  created() {
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    //console.log(this.id);
    this.getStructure(this.id);
  },
  methods: {
    // downloadData(index) {
    //   let transcriptId = this.totalData[index].totalData;
    //   export2Excel(
    //     this.columns,
    //     this.totalData[index].structureList,
    //     transcriptId
    //   );
    // },
    downloadData(transcriptId) {
      //console.log(transcriptId, this.version);
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get(
          "/bena/server/gooal/gene/structure/transcriptSeq/?transcriptId=" +
            transcriptId +
            "&version=" +
            this.version,{
          headers: { Authorization: token },
        }
        )
        .then(function (response) {
          //console.log(response);
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
    hide(index) {
      //console.log(index);
      let totalData = this.totalData;
      totalData[index].show = false;
      this.totalData = totalData;
    },
    show(index) {
      //console.log(index);
      let totalData = this.totalData;
      totalData[index].show = true;
      this.totalData = totalData;
    },
    getStructure(id) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/gene/structure/" + id,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          let arr = response.data;
          
          for (let i = 0; i < arr.length; i++) {
            let px=850/(parseFloat(arr[i].transcriptEnd)-parseFloat(arr[i].transcriptStart));
            arr[i].lineWidth=(parseFloat(arr[i].transcriptEnd)-parseFloat(arr[i].transcriptStart))*px;
            arr[i].show = true;
            let mleft = 0;
            for (let j = 0; j < arr[i].structureList.length; j++) {
              if (arr[i].structureList[j].feature == "'3'UTR") {
                arr[i].structureList[j].color = "#ffb902";
              } else if (arr[i].structureList[j].feature == "CDS") {
                arr[i].structureList[j].color = "#09b";
              } else if (arr[i].structureList[j].feature == "5'UTR") {
                arr[i].structureList[j].color = "#f87481";
              } else {
                arr[i].structureList[j].color = "#c7e1ff";
              }
              // arr[i].structureList[j].color =
              //   "#" + Math.random().toString(16).slice(-6);
              arr[i].structureList[j].width =
                (arr[i].structureList[j].end -arr[i].structureList[j].start)*px;
               arr[i].structureList[j].mleft = (arr[i].structureList[j].start -arr[i].transcriptStart)*px;
            }
          }
          //console.log(arr);
          that.totalData = arr;
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.downloadbtn {
  width: 100px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  background: seagreen;
  color: #fff;
  display: block;
  font-size: 13px;
  text-decoration: none;
  margin-top: 1px;
}
.border {
  border: 1px dashed #ccc;
  padding: 20px;
  margin: 20px 0 0 0;
}
.title {
  color: seagreen;
}
.tag {
  /* margin-left: 580px; */
  margin-bottom: 20px;
  width: auto;
  height: 40px;
  font-size: 14px;
  line-height: 40px;

  display: flex;
}
.ge {
  flex: 1;
  font-size: 16px;
  color: seagreen;
}
.tag .ge1{
  flex: 1;
}
.tagc {
  
  background-color: #ffffff;
}
.tagc ul {
  margin: 0;
  padding: 0;
}
.tagc li {
  float: left;
  list-style: none;
  margin-left: 20px;
  display: flex;
}
.tag .mgleft {
  margin-left: 30px;
  margin-right: 20px;
}
.tag .div {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  /* background-color: rgb(176, 183, 221); */
}
.tag .one {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: rgb(176, 183, 221);
}
.tag .two {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: rgb(201, 110, 110);
}
.tag .three {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: rgb(35, 125, 177);
}
.tag .four {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: rgb(212, 177, 59);
}
.five {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #61daa5;
}
.childTitle {
  margin-bottom: 35px;
}
.line {
  display: auto;
   /* border: 1px solid red; */
   position: relative;
}
.line hr{

}
.line .lineItem {
  float: left;
  margin-top: -28px;
  margin-left: 0px;
  /* width: 66px; */
  height: 35px;
  position: absolute;
  /* border-radius: 15px; */
  /* background-color: rgb(212, 177, 59); */
 
}
.line .lineItemOne {
  float: left;
  margin-top: -28px;
  margin-left: 0px;
  width: 66px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(212, 177, 59);
}
.line .lineItemTwo {
  float: left;
  margin-top: -28px;
  margin-left: 30px;
  width: 28px;
  height: 35px;
  /* border-radius: 12px; */
  background-color: rgb(176, 183, 221);
}
.line .lineItemThree {
  float: left;
  margin-top: -28px;
  margin-left: 80px;
  width: 85px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(35, 125, 177);
}
.line .lineItemFour {
  float: left;
  margin-top: -28px;
  margin-left: 20px;
  width: 66px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(212, 177, 59);
}
.line .lineItemFive {
  float: left;
  margin-top: -28px;
  margin-left: 50px;
  width: 188px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(35, 125, 177);
}
.line .lineItemSix {
  float: left;
  margin-top: -28px;
  margin-left: 100px;
  width: 48px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(35, 125, 177);
}
.line .lineItemSeven {
  float: right;
  margin-top: -28px;
  width: 78px;
  height: 35px;
  /* border-radius: 15px; */
  background-color: rgb(201, 110, 110);
}
.el-button {
  width: 100px;
  height: 35px;
  background: seagreen;
  color: #fff;
  line-height: 10px;
  border-radius: 0;
}
.download {
  /* margin: 70px 0 5px 700px; */
  width: 100%;
  height: 60px;
  position: relative;
  top: 18px;
  text-align: right;
  /* bottom: 10px; */
  display: flex;
}
.download .btnge {
  flex: 1;
}
</style>